const styles = `:host{box-sizing:border-box;flex-direction:column;width:100%;display:flex}`;export default styles;